<g>
	<path
		d="M23.854 10.01l-2.84-2.861c-.094-.095-.222-.148-.354-.148h-12.16c-.276 0-.5.224-.5.5v16c0 .276.224.5.5.5h15c.276 0 .5-.224.5-.5v-13.139c0-.132-.052-.259-.146-.352Zm-.854 12.991h-14v-15h11.452l2.548 2.567v12.433Z"
	/>
	<path
		d="M20 18.001h-8c-.276 0-.5.224-.5.5 0 .276.224.5.5.5h8c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5Z"
	/>
	<path
		d="M20 15.001h-8c-.276 0-.5.224-.5.5 0 .276.224.5.5.5h8c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5Z"
	/>
	<path
		d="M20 12.001h-8c-.276 0-.5.224-.5.5 0 .276.224.5.5.5h8c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5Z"
	/>
	<path
		d="M6.5 15.001h-5.5v-14h11.452l2.547 2.567v1.933c0 .276.224.5.5.5 .276 0 .5-.224.5-.5v-2.139c0-.132-.052-.258-.146-.352l-2.839-2.861c-.094-.095-.222-.148-.355-.148h-12.159c-.276 0-.5.224-.5.5v15c0 .276.224.5.5.5h6c.276 0 .5-.224.5-.5 0-.276-.224-.5-.5-.5Z"
	/>
	<path
		d="M5.999 10.001h-1.999c-.276 0-.5.224-.5.5 0 .276.224.5.5.5h2c.276 0 .5-.224.5-.5 0-.276-.225-.5-.501-.5Z"
	/>
	<path
		d="M5.999 7.001h-1.999c-.276 0-.5.224-.5.5 0 .276.224.5.5.5h2c.276 0 .5-.224.5-.5 0-.276-.225-.5-.501-.5Z"
	/>
	<path
		d="M12.5 4.501c0-.276-.224-.5-.5-.5h-8c-.276 0-.5.224-.5.5 0 .276.224.5.5.5h8c.276 0 .5-.224.5-.5Z"
	/>
</g>
